export default {
	init() {
		const $form = $('#tr-vprasalnik-form')
		if ($form.length === 0) return

		const formEl = $form.get(0)
		const actionInput = formEl ? formEl.querySelector('input[name="action"]') : null
		if (!actionInput || actionInput.value !== 'tr_save_vprasalnik') return

		function getMaxChoices(proxy) {
			if (!proxy) return 0
			const max = parseInt(proxy.getAttribute('data-max-choices') || '0', 10)
			return isNaN(max) ? 0 : max
		}

		function countChecked(groupId) {
			const boxes = formEl.querySelectorAll('input[type="checkbox"][data-checkbox-group="' + groupId + '"]')
			let checked = 0
			boxes.forEach(b => {
				if (b.checked) checked++
			})
			return checked
		}

		function updateProxy(groupId) {
			const proxy = formEl.querySelector('input[data-checkbox-proxy="' + groupId + '"]')
			if (!proxy) return
			const checked = countChecked(groupId)
			const max = getMaxChoices(proxy)
			const ok = max > 0 ? (checked >= 1 && checked <= max) : checked >= 1
			proxy.value = ok ? '1' : ''
		}

		// Pri vprašanjih z omejitvijo (največ N) onemogoči neizbrane checkboxe, ko je limit dosežen.
		function updateMaxLimit(groupId) {
			const proxy = formEl.querySelector('input[data-checkbox-proxy="' + groupId + '"]')
			const max = getMaxChoices(proxy)
			if (max <= 0) return
			const boxes = formEl.querySelectorAll('input[type="checkbox"][data-checkbox-group="' + groupId + '"]')
			const atLimit = countChecked(groupId) >= max
			boxes.forEach(b => {
				if (!b.checked) {
					b.disabled = atLimit
					const wrap = b.closest('label')
					if (wrap) wrap.classList.toggle('opacity-40', atLimit)
				}
			})
		}

		function updateOther(groupId) {
			const otherBox = formEl.querySelector('input[type="checkbox"][data-checkbox-group="' + groupId + '"][data-other-option="1"]')
			const otherWrap = formEl.querySelector('[data-other-wrap="' + groupId + '"]')
			const otherInput = formEl.querySelector('input[data-other-input="' + groupId + '"]')
			if (!otherWrap || !otherInput) return
			const show = otherBox && otherBox.checked
			if (show) {
				otherWrap.classList.remove('hidden')
				otherInput.required = true
			} else {
				otherWrap.classList.add('hidden')
				otherInput.required = false
				otherInput.value = ''
			}
		}

		function isQuestionValid(qEl) {
			if (!qEl) return true
			const radios = qEl.querySelectorAll('input[type="radio"]')
			if (radios && radios.length) {
				for (const r of radios) {
					if (r.checked) return true
				}
				return false
			}

			const boxes = qEl.querySelectorAll('input[type="checkbox"][data-checkbox-group]')
			if (boxes && boxes.length) {
				const proxy = qEl.querySelector('input[data-checkbox-proxy]')
				const otherBox = qEl.querySelector('input[type="checkbox"][data-other-option="1"]')
				const otherInput = qEl.querySelector('input[data-other-input]')
				let checked = 0
				boxes.forEach(b => {
					if (b.checked) checked++
				})
				const max = getMaxChoices(proxy)
				const basicOk = max > 0 ? (checked >= 1 && checked <= max) : checked >= 1
				if (!basicOk) return false
				if (otherBox && otherBox.checked) {
					return !!(otherInput && otherInput.value && otherInput.value.trim() !== '')
				}
				return true
			}

			return true
		}

		function setQuestionError(qEl, show) {
			if (!qEl) return
			const err = qEl.querySelector('.tr-q-error')
			if (!err) return
			if (show) err.classList.remove('hidden')
			else err.classList.add('hidden')
		}

		function validateAllQuestions() {
			const questions = formEl.querySelectorAll('.tr-q')
			let allOk = true
			questions.forEach(q => {
				const ok = isQuestionValid(q)
				setQuestionError(q, !ok)
				if (!ok) allOk = false
			})
			return allOk
		}

		// Prime proxies on load
		formEl.querySelectorAll('input[data-checkbox-proxy]').forEach(proxy => {
			const groupId = proxy.getAttribute('data-checkbox-proxy')
			if (groupId) {
				updateProxy(groupId)
				updateMaxLimit(groupId)
				updateOther(groupId)
			}
		})

		formEl.addEventListener('change', (e) => {
			const t = e.target
			if (t && t.matches && t.matches('input[type="checkbox"][data-checkbox-group]')) {
				updateProxy(t.getAttribute('data-checkbox-group'))
				updateMaxLimit(t.getAttribute('data-checkbox-group'))
				updateOther(t.getAttribute('data-checkbox-group'))
			}

			const q = t && t.closest ? t.closest('.tr-q') : null
			if (q) {
				setQuestionError(q, !isQuestionValid(q))
			}
		})

		formEl.addEventListener('input', (e) => {
			const t = e.target
			if (t && t.matches && t.matches('input[data-other-input]')) {
				const q = t.closest ? t.closest('.tr-q') : null
				if (q) setQuestionError(q, !isQuestionValid(q))
			}
		})

		// On submit click, show per-question messages if something missing.
		formEl.addEventListener('click', (e) => {
			const btn = e.target && e.target.closest ? e.target.closest('button[type="submit"]') : null
			if (!btn) return
			validateAllQuestions()
		})

		$form.on('submit', function(e) {
			e.preventDefault()

			const allOk = validateAllQuestions()
			if (!allOk) return

			const $submitBtn = $form.find('button[type="submit"]')
			$submitBtn.prop('disabled', true)

			const formData = new FormData(this)
			const form_error_element = $form.find('.form-response.error')
			const getErrorMessage = (payload, fallback = 'Napaka pri shranjevanju. Osvežite stran in poskusite znova.') => {
				if (typeof payload === 'string' && payload.trim() !== '') {
					return payload
				}

				if (payload && typeof payload === 'object') {
					if (typeof payload.error === 'string' && payload.error.trim() !== '') {
						return payload.error
					}

					if (typeof payload.message === 'string' && payload.message.trim() !== '') {
						return payload.message
					}
				}

				return fallback
			}

			$.ajax({
				url: my_ajax_object.ajax_url,
				type: 'POST',
				data: formData,
				processData: false,
				contentType: false,
				dataType: 'json',
					success: function (response) {
						if (response && response.success) {
							form_error_element
							.text('Podatki so shranjeni.')
							.removeClass('hidden text-red border-red')
							.addClass('success text-blue border-blue')
							.show()

							setTimeout(function() {
								window.location.href = response.data.redirect
							}, 1000)
						} else {
							const msg = getErrorMessage(response?.data, 'Napaka pri shranjevanju.')
							form_error_element
								.text(msg)
								.removeClass('hidden success text-blue border-blue')
								.addClass('text-red border-red')
							$submitBtn.prop('disabled', false)
						}
					},
					error: function (jqXHR) {
						let msg = getErrorMessage(jqXHR?.responseJSON?.data, '')
						if (!msg) {
							msg = getErrorMessage(jqXHR?.responseJSON?.message, '')
						}
						if (!msg) {
							msg = 'Napaka pri shranjevanju. Osvežite stran in poskusite znova.'
						}

						form_error_element
							.text(msg)
							.removeClass('hidden success text-blue border-blue')
							.addClass('text-red border-red')
						$submitBtn.prop('disabled', false)
					}
				})
		})
	}
}
